import * as React from 'react';
import classNames from 'classnames';
import { Star as StarIcon, DragIndicator, ExpandLess, ExpandMore } from '@markinson/uicomponents-v2/SvgIcons';
import * as styles from './LookUpList.scss';
import { inlineStyles } from './LookUpList.styles';
import { DISPLAY_FIELD_ADDITIONAL_PRIMARY, DISPLAY_FIELD_ADDITIONAL_SECONDARY, DISPLAY_FIELD_DESCRIPTION_PRIMARY, DISPLAY_FIELD_DESCRIPTION_SECONDARY, DISPLAY_FIELD_MAIN_PRIMARY, DISPLAY_FIELD_MAIN_SECONDARY } from './LookUpList.constants';

export const ListItemInner = (props) => {
  const { item, dataKeys, renderCustomItemSection, browseLookUp, expandable, cascadingListFields, cascadingListKey, cascadingOpen, index, isDraggable, toggleCollapse, lastLinePosition } = props;

  const mainPrimary = item[dataKeys[DISPLAY_FIELD_MAIN_PRIMARY]];
  const mainSecondary = item[dataKeys[DISPLAY_FIELD_MAIN_SECONDARY]];
  const secondaryDescription = item[dataKeys[DISPLAY_FIELD_DESCRIPTION_SECONDARY]];
  const primaryDescriptionKey = dataKeys[DISPLAY_FIELD_DESCRIPTION_PRIMARY];
  const additionalPrimaryKey = dataKeys[DISPLAY_FIELD_ADDITIONAL_PRIMARY];
  const additionalSecondary = item[dataKeys[DISPLAY_FIELD_ADDITIONAL_SECONDARY]];

  const _toggleCollapse = (e) => {
    toggleCollapse(index + 1);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div style={inlineStyles.listItemInner}>
      <div>
        {isDraggable && <DragIndicator />}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: 8 }}>
        {(browseLookUp && (item as any).Primary) &&
          <div style={inlineStyles.favoriteBrowseItemIndicator}>
            {<StarIcon style={inlineStyles.favoriteStarIcon} />}
          </div>
        }
        {/* Row 1 */}
        <label
          className={styles.lookupListingItemTitleSection}
          style={{ whiteSpace: 'pre' }}
          title={`${mainPrimary} - ${mainSecondary}`}>
          {mainPrimary} {mainSecondary && ` - ${mainSecondary}`}
        </label>
        {/* Row 2 */}
        {item[primaryDescriptionKey] &&
          <label title={`${item[primaryDescriptionKey]}`} className={classNames({
            [styles.lookupListingItemMetaSection]: secondaryDescription,
            [styles.lookupListingItemMetaSectionSingle]: !secondaryDescription,
            [styles.lookupListingItemRow1]: secondaryDescription,
            [styles.lookupListingItemRowFull]: secondaryDescription,
            [styles.lookupListingItemUser]: primaryDescriptionKey === 'timeStamp' || primaryDescriptionKey === 'EnterDate'
          })}>
            {item[primaryDescriptionKey]}
          </label>}
        {/* Row 3 without  Secondary description */}
        {
          secondaryDescription &&
          <label title={`${secondaryDescription}`} className={classNames(styles.lookupListingItemRow2, lastLinePosition === 'right' && styles.alignRight, {
            [styles.lookupListingItemMetaSection]: secondaryDescription,
            [styles.lookupListingItemMetaSectionSingle]: !secondaryDescription
          })}>
            {secondaryDescription}
          </label>
        }
        {/* Row 3 with  Secondary description */}
        {
          (item[additionalPrimaryKey] || additionalSecondary) &&
          <label title={`${item[additionalPrimaryKey]}`} className={classNames({
            [styles.lookupListingItemMetaSection]: additionalSecondary,
            [styles.lookupListingItemMetaSectionSingle]: !additionalSecondary,
            [styles.lookupListingItemRow1]: additionalSecondary,
            [styles.lookupListingItemRowFull]: !additionalSecondary,
            [styles.lookupListingItemUser]: additionalPrimaryKey === 'timeStamp' || additionalPrimaryKey === 'EnterDate'
          })}>
            {item[additionalPrimaryKey]}{additionalSecondary && ` - ${additionalSecondary}`}
          </label>
        }
        {
          renderCustomItemSection && <div>
            {renderCustomItemSection(item)}
          </div>
        }
        {
          (expandable && (cascadingListFields && (item as any)[cascadingListKey] && ((cascadingOpen[index + 1])) ?
            <ExpandLess onClick={_toggleCollapse} style={inlineStyles.nestedListExpansionIcon} /> : <ExpandMore onClick={_toggleCollapse} style={inlineStyles.nestedListExpansionIcon} />))
        }
      </div>
    </div >);
};

const ListItemObj = (props) => {
  const { item, dataKeys, renderCustomItemSection, browseLookUp, expandable, cascadingListFields, cascadingListKey, cascadingOpen, index, isDraggable, toggleCollapse } = props;
  const _toggleCollapse = (e) => {
    toggleCollapse(index + 1);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div style={inlineStyles.listItemInner}>
      <div>
        {isDraggable && <DragIndicator />}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: 8 }}>
        {(browseLookUp && (item as any).Primary) &&
          <div style={inlineStyles.favoriteBrowseItemIndicator}>
            {<StarIcon style={inlineStyles.favoriteStarIcon} />}
          </div>
        }
        {/* Row 1 */}
        <label
          className={styles.lookupListingItemTitleSection}
          style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
          title={`${item[dataKeys.Row1.description]} - ${item[dataKeys.Row1.additionalDescription]}`}>
          <span>
            {item[dataKeys.Row1?.description]}
            {item[dataKeys.Row1?.additionalDescription] && ` - ${item[dataKeys.Row1.additionalDescription]}`}
          </span>
          {item[dataKeys.Row1?.col2] && <span>{`${item[dataKeys.Row1?.col2]}`}</span>}
        </label>
        {/* Row 2 */}
        {item[dataKeys?.Row2.description] &&
          <label title={`${item[dataKeys.Row2.description]}`} className={classNames({
            [styles.lookupListingItemMetaSection]: item[dataKeys.Row2.additionalDescription],
            [styles.lookupListingItemMetaSectionSingle]: !item[dataKeys.Row2.additionalDescription],
            [styles.lookupListingItemRow1]: item[dataKeys.Row2.additionalDescription],
            [styles.lookupListingItemRowFull]: item[dataKeys.Row2.additionalDescription],
            [styles.lookupListingItemUser]: dataKeys.Row2.additionalDescription === 'timeStamp' || dataKeys.Row2.additionalDescription === 'EnterDate'
          })}>
            {item[dataKeys.Row2.description]}
            {item[dataKeys.Row2.additionalDescription] && ` - ${item[dataKeys.Row2?.additionalDescription]}`}
          </label>}
        {/* Row 3 */}
        {
          (item[dataKeys.Row3?.description]) &&
          <label title={`${item[dataKeys.Row3.description]}`} className={classNames({
            [styles.lookupListingItemMetaSection]: item[dataKeys.Row3.additionalDescription],
            [styles.lookupListingItemMetaSectionSingle]: !item[dataKeys.Row3.additionalDescription],
            [styles.lookupListingItemRow1]: item[dataKeys.Row3.additionalDescription],
            [styles.lookupListingItemRowFull]: !item[dataKeys.Row3.additionalDescription],
            [styles.lookupListingItemUser]: dataKeys.Row3.description === 'timeStamp' || dataKeys.Row3.description === 'EnterDate'
          })}>
            {item[dataKeys.Row3.description]}
            {item[dataKeys.Row3?.additionalDescription] && ` - ${item[dataKeys.Row3.additionalDescription]}`}
          </label>
        }
        {/* Row 4 */}
        <label
          className={styles.lookupListingItemMetaSection}
          style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
        >

          <span>
            {item[dataKeys.Row4?.description]}
            {item[dataKeys.Row4?.additionalDescription] && ` - ${item[dataKeys.Row4.additionalDescription]}`}
          </span>
         {item[dataKeys.Row4?.col2] && <span>{`${item[dataKeys.Row4?.col2]}`}</span>}
        </label>
        {
          renderCustomItemSection && <div>
            {renderCustomItemSection(item)}
          </div>
        }
        {
          (expandable && (cascadingListFields && (item as any)[cascadingListKey] && ((cascadingOpen[index + 1])) ?
            <ExpandLess onClick={_toggleCollapse} style={inlineStyles.nestedListExpansionIcon} /> : <ExpandMore onClick={_toggleCollapse} style={inlineStyles.nestedListExpansionIcon} />))
        }
      </div>
    </div >);
};

export default ListItemObj;
